const tables = [
  {
    name: "Name",
  },
  {
    name: "Phone",
  },
  {
    name: "Email",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
